import { Component, OnInit } from "@angular/core";
import { UntypedFormGroup } from "@angular/forms";

import { Observable, Subject } from "rxjs";

import { DffRouteParams } from "@dffedb/router";
import { DffError, UnsubscribeOnDestroy } from "@dffedb/util";

import { DeeplinkSandbox } from "../services/deeplink.sandbox";

@Component({
    templateUrl: "./deeplink-note.component.html"
})
export class DeeplinkNoteComponent extends UnsubscribeOnDestroy implements OnInit {
    public observable$ = new Subject<void>();
    public formGroup$: Observable<UntypedFormGroup>;

    constructor(private readonly routeParams: DffRouteParams, private readonly sandbox: DeeplinkSandbox) {
        super();
    }

    public async ngOnInit(): Promise<void> {
        try {
            if (!(await this.sandbox.loginMedGemteCredentials())) {
                this.sandbox.redirectTilLogin();
                return;
            }
            const noteId = +this.routeParams.get("noteid");
            const installation = await this.sandbox.findInstallationForNoteId(noteId);
            if (!installation) {
                throw new DffError(`Kan ikke finde installation tilhørende note ${noteId}`);
            }
            this.sandbox.vaelgInstallation(installation);
            this.sandbox.redirectTilNoter(noteId);
        } catch (error) {
            this.observable$.error(error);
        }
    }
}
